import React from 'react';
// import {ReactComponent as StarIcon} from '@/assets/icons/sports/star.svg';
import {useTranslation} from 'react-i18next';
import globalStore from '@/services/global.state';
import styles from './index.module.scss';
export interface HotItemProps {
  title: string;
  headerRightContent?: React.ReactNode;
  className?: string;
  middleContent: React.ReactNode;
  marketList?: {price: string; outcomeName: string}[];
  uri?: string;
  vsType?: string;
}

const HotItem = ({
  title,
  className,
  headerRightContent,
  middleContent,
  marketList,
  uri = '',
}: HotItemProps) => {
  const {t} = useTranslation();
  return (
    <div
      className={`${
        className || ''
      } rounded-lg flex flex-col gap-2 pb-2 w-full`}
      onClick={() => {
        globalStore.openSports.next(uri);
      }}>
      <div
        className={`h-8 flex flex-row gap-3 px-2 items-center ${styles.border}`}>
        <span className="text-t2 text-xs flex-1 overflow-hidden text-ellipsis whitespace-nowrap font-weight-500">
          {title}
        </span>
        <div className="flex flex-row gap-2 items-center">
          {headerRightContent}
          {/* <StarIcon className="size-4 text-t3" /> */}
        </div>
      </div>
      {middleContent}
      <div className="flex flex-row gap-2 pl-2 pr-2">
        {marketList && marketList.length <= 3 ? (
          marketList.map((item, index) => (
            <div
              className="flex flex-col flex-1 h-14 justify-center items-center gap-1 bg-[#F5F4F1] rounded pt-1 pb-1 pl-3 pr-3"
              key={index}>
              <span className="text-c1 text-base leading-[1.25rem]">
                {item.price}
              </span>
              <span className="text-t3 text-xs leading-[0.9375rem]">
                {item.outcomeName}
              </span>
            </div>
          ))
        ) : (
          <div className="flex flex-col flex-1 h-14 justify-center items-center gap-1 bg-[#F5F4F1] rounded pt-1 pb-1 pl-3 pr-3">
            <span className="text-t1 text-base leading-[1.25rem]">
              {t('home.label.availOutcomes', {
                count: marketList?.length || 0,
              })}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default HotItem;
